import { jsx as _jsx } from "react/jsx-runtime";
import { setLanguageCookie } from "@jti/ui";
import "./ShopLandingPage.scss";
const rootClassName = "aem-shopLandingPage";
export const ShopPageTeaser = ({ title, path, backgroundImage: image, relatedLanguage }) => {
    const selectLocation = (path, selectedLanguage) => {
        setLanguageCookie(selectedLanguage);
        window.location.assign(path);
    };
    return (_jsx("li", { className: `${rootClassName}__teaser`, tabIndex: 0, role: "link", "data-testid": "shop-page-teaser", style: { backgroundImage: `url('${image}')`, backgroundSize: "cover", borderRadius: "10px" }, onClick: () => selectLocation(path, relatedLanguage), onKeyDown: (e) => e.key === "Enter" && selectLocation(path, relatedLanguage), children: _jsx("strong", { className: `${rootClassName}__teaser-title`, children: title }) }));
};
//# sourceMappingURL=ShopPageTeaser.js.map